import React, { useState } from 'react';
import { ExternalLink, Copy, Check } from 'lucide-react';

// Navigateurs Android qui ne savent pas installer une PWA (Mi Browser/scanner QR Xiaomi, WebViews d'apps, etc.)
const NON_CHROME = /; wv\)|MiuiBrowser|XiaoMi|SamsungBrowser|EdgA|OPR\/|OPX|YaBrowser|UCBrowser|HeyTapBrowser|HuaweiBrowser|FBAN|FBAV|Instagram|WhatsApp|Line\/|Snapchat|musical_ly|Firefox/i;

export const isAndroidRealChrome = () => {
  const ua = navigator.userAgent || '';
  return /Chrome\/\d+/i.test(ua) && !NON_CHROME.test(ua);
};

const installUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.set('install', '1');
  return url;
};

const chromeIntent = () => {
  const url = installUrl();
  return `intent://${url.host}${url.pathname}${url.search}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(url.toString())};end`;
};

export const AndroidOpenInChrome = ({ dark = false }) => {
  const [copied, setCopied] = useState(false);
  const realChrome = isAndroidRealChrome();
  const muted = dark ? 'text-zinc-400' : 'opacity-80';

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(installUrl().toString());
      setCopied(true);
    } catch (e) {
      window.prompt('Copie ce lien puis colle-le dans Chrome :', installUrl().toString());
    }
  };

  return (
    <div className="space-y-2" data-testid="android-open-in-chrome">
      {!realChrome && (
        <>
          <p className="text-sm font-semibold" data-testid="android-non-chrome-warning">
            Ce navigateur ne permet pas d'installer Métro-Taxi. Ouvre le lien dans Chrome :
          </p>
          <div className="flex gap-2">
            <a href={chromeIntent()} data-testid="android-open-chrome-btn"
              className="flex-1 bg-black text-yellow-400 font-semibold py-2.5 px-3 rounded-xl flex items-center justify-center gap-2 text-sm">
              <ExternalLink className="w-4 h-4" /> Ouvrir dans Chrome
            </a>
            <button onClick={copy} data-testid="android-copy-link-btn"
              className="px-3 py-2.5 border-2 border-current/20 rounded-xl text-sm flex items-center gap-1">
              {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />} {copied ? 'Copié' : 'Copier le lien'}
            </button>
          </div>
        </>
      )}
      <p className={`text-xs ${muted}`} data-testid="android-icon-tip">
        Icône absente après l'installation ? Regarde dans la liste de tes applis. Sur Xiaomi / Redmi / POCO :
        Paramètres → Applis → Chrome → Autres autorisations → active « Raccourcis sur l'écran d'accueil ».
      </p>
    </div>
  );
};
